import Api from 'api';
import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import {
  IFarmerPendingKpiInfo,
  IFarmerSetKpiValues,
  IFarmerKpiSetChosenAssessment,
  IFarmerSetKpisInfo,
  KpiValueModel,
  IFarmerSetChosenCategory,
  IFarmerKpisSetChosenEmissionsCategory,
  IFarmerKpiSetChosenEmissionsAssessment,
  IFarmerKpisSetDrillDwonData,
  IFarmerSetChosenDrillDownCategory,
  IFarmerKpiSetDrillDownChosenAssessment,
  IFarmerKpiSetDrillDownSelectedParts, IFarmerFilterSpecies, IFarmerFilterProject,
} from './types';
import { IRetailerFilterProject, IRetailerFilterSpecies } from '../retailerKpi/types';

const farmerKpiPendingAction = (isLoading: boolean): IFarmerPendingKpiInfo => ({
  type: 'FARMER_KPI_PENGING_KPI_INFO',
  payload: isLoading,
});

const farmerKpiSetKpiInfoAction = (
  data: Array<KpiValueModel>,
): IFarmerSetKpisInfo => ({
  type: 'FARMER_KPI_SET_KPIS_INFO',
  payload: data,
});

const farmerKpiSetKpiValuesAction = (
  kpiValues: Array<KpiValueModel>,
): IFarmerSetKpiValues => ({
  type: 'FARMER_KPI_SET_KPI_VALUES',
  payload: kpiValues,
});

export const setFarmerKpiChosenCategory = (
  category: string,
): IFarmerSetChosenCategory => ({
  type: 'FARMER_KPI_SET_CHOSEN_CATEGORY',
  payload: category,
});

export const setFarmerFilterSpecies = (
  species: any,
): IFarmerFilterSpecies => ({
  type: 'FARMER_SET_FILTER_SPECIES',
  payload: species,
});

export const setFarmerFilterProject = (
  projects: any,
): IFarmerFilterProject => ({
  type: 'FARMER_SET_FILTER_PROJECT',
  payload: projects,
});

export const setFarmersKpiChosenAssessment = (
  assId: string,
): IFarmerKpiSetChosenAssessment => ({
  type: 'FARMER_KPI_SET_CHOSEN_ASSESSMENT',
  payload: assId,
});

export const setFarmerKpiChosenEmissionsCategory = (
  category: string,
): IFarmerKpisSetChosenEmissionsCategory => ({
  type: 'FARMER_KPI_SET_CHOSEN_EMISSIONS_CATEGORY',
  payload: category,
});

export const setFarmerChosenEmissionsAssessment = (
  assessmentName: string,
): IFarmerKpiSetChosenEmissionsAssessment => ({
  type: 'FARMER_KPI_SET_CHOSEN_EMISSIONS_ASSESSMENT',
  payload: assessmentName,
});

const setDrillDownDataAction = (
  data: Array<KpiValueModel>,
): IFarmerKpisSetDrillDwonData => ({
  type: 'FARMER_KPI_SET_DRILL_DOWN_DATA',
  payload: data,
});

export const setFarmerKpiChosenDrillDownCategory = (
  category: string,
): IFarmerSetChosenDrillDownCategory => ({
  type: 'FARMER_KPI_SET_CHOSEN_DRILL_DOWN_CATEGORY',
  payload: category,
});

export const setFarmersKpiDrillDownChosenAssessment = (
  assId: string,
): IFarmerKpiSetDrillDownChosenAssessment => ({
  type: 'FARMER_KPI_SET_DRILL_DOWN_CHOSEN_ASSESSMENT',
  payload: assId,
});

export const setFarmerKpiDrillDownSelectedParts = (
  partId: number,
): IFarmerKpiSetDrillDownSelectedParts => ({
  type: 'FARMER_KPI_SET_DRILL_DOWN_SELECTED_PARTS',
  payload: partId,
});

export const getFarmerKpi: ActionCreator<
  ThunkAction<Promise<any>, any, null, any>
> = (info) => async (dispatch: Dispatch) => {
  dispatch(farmerKpiPendingAction(true));
  let data = {
    "selectedAssessments": info?.Assessments || [],
    "selectedSpecies": info?.SpeciesFilterValues || [],
    "selectedProcessors": info?.selectedProcessors || [],
    "selectedProjects": info?.selectedProjects || [],
    "selectedSystemTypes": info?.selectedSystemTypes || [],
    "DrillDown" : true
}
  try {
    const [generalKpiResponse, drillldownKpiResponse] = await Promise.all([
      Api(false).post('/api/KPI/GetKpiValues', {...data, DrillDown: false}),
      Api(false).post('/api/KPI/GetKpiValues', {...data, DrillDown: true}),
    ]);

    dispatch(farmerKpiSetKpiValuesAction(generalKpiResponse.data));
    dispatch(setDrillDownDataAction(drillldownKpiResponse.data));
  } catch (e) {
    console.log(e);
  } finally {
    dispatch(farmerKpiPendingAction(false));
  }
};
